import api from "@/router/api";

export default {
  async getEncontros(page, size, atividadeId) {
    const response = await api.get("/encontros", {
      params: {
        atividadeId,
        page,
        size,
      },
    });
    return response.data.content || response.data;
  },

  async postUmEncontro(atividadeId, dadosEncontro) {
    const response = await api.post("/encontros", dadosEncontro, {
      params: { atividadeId },
    });
    return response.data;
  },

  async postMuitosEncontros(atividadeId, listaEncontros) {
    const payload = Array.isArray(listaEncontros)
      ? { encontros: listaEncontros }
      : listaEncontros;
    const response = await api.post(
      "/encontros/adiciona-muitos",
      payload,
      {
        params: { atividadeId },
      }
    );
    return response.data;
  },

  async putEncontro(encontroId, dadosEncontro) {
    const response = await api.put("/encontros", dadosEncontro, {
      params: { encontroId },
    });
    return response.data;
  },

  async deletEncontro(encontroId) {
    const response = await api.delete("/encontros", {
      params: { encontroId },
    });
    return response.data;
  },

  async cancelarEncontro(encontroId, motivo) {
    const response = await api.get("/encontros/cancelar", {
      params: {
        encontroId,
        motivo,
      },
    });
    return response.data;
  },

  async participacoesEncontro(page, size, atividadeId, participanteId) {
    const response = await api.get("/encontros/participacoes", {
      params: {
        atividadeId,
        participanteId,
        page,
        size,
      },
      public: true,
    });
    return response.data.content || response.data;
  },

  async concluirEncontro(encontroId) {
    const response = await api.put("/encontros/concluir", null, {
      params: { encontroId },
    });
    return response.data;
  },

  async downloadListaAssinatura(encontroId) {
    const response = await api.get(
      `/encontros/lista-assinatura/${encontroId}`,
      {
        responseType: "blob",
      }
    );
    return response.data;
  },
};
